
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { InfluencerStreamApiModel } from './model/influencer-stream.api.model';
import { Observable } from 'rxjs';
import { MentionsSearchResponseModel } from '../mentions/model/mentions-search-response.model';

@Injectable()
export class InfluencerStreamsApi {

    constructor(
        private neptuneApi: NeptuneApi,
    ) {
    }

    getStreams(): Observable<InfluencerStreamApiModel[]> {

        return this.neptuneApi.api<InfluencerStreamApiModel[]>(
            '/influencerstreams',
            null,
            HttpVerbsEnum.GET
        );
    }

    upsertStream(stream: InfluencerStreamApiModel): Observable<number> {
        delete stream.editing;
        delete stream.loading;
        if (stream.id) {
            return this.neptuneApi.api(
                `/influencerstreams/${stream.id}`,
                stream,
                HttpVerbsEnum.PUT
            ).pipe(map(x => stream.id));
        } else {
            return this.neptuneApi.api(
                '/influencerstreams',
                stream,
                HttpVerbsEnum.POST
            );
        }
    }

    deleteStream(id: number): Observable<void> {
        return this.neptuneApi.api(
            `/influencerstreams/${id}`,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    setStreamOrder(ids: number[]): Observable<void> {
        return this.neptuneApi.api(
            '/influencerstreams/order',
            ids,
            HttpVerbsEnum.POST
        );
    }

    getStreamContent(id: number, lastFetch: Date, start: number): Observable<MentionsSearchResponseModel> {
        const query = {};
        if (lastFetch) {
            query['since'] = lastFetch.getTime();
        }
        if (start) {
            query['start'] = start;
        }
        return this.neptuneApi.api(
            `/influencerstreams/${id}/mentions`,
            null,
            HttpVerbsEnum.POST,
            query
        );
    }
}
